var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFitnessPlayerInstructorIconVision = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8.99998,
    r: 8.49998,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18C23.5 18 16 24.7892 8.50004 18C1 21.5158 1 29.3153 1 29.3153C8.50004 33.785 22.8182 34.6523 31 29.3153C29.9286 21.3946 23.5 18 23.5 18Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFitnessPlayerInstructorIconVision, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FitnessPlayer_Instructor_Icon_Vision.553e3d6e.svg";
export { ForwardRef as ReactComponent };